import Api from './api';

export default {
  syncProdDatabase: () => Api.post('tools/syncProdDatabase', null, { timeout: 5 * 60 * 1000 }),
};
